module.exports = __webpack_public_path__ + "static/img/landing-image-1.f31901ce.jpg";